import React, { useContext } from 'react';
import {
  MFBeaconButton,
  MFBeaconIconButton,
  MFBeaconModal
} from '../Beacon/BeaconComponents';
import { FlowContext } from '../../core/flow-engine';
import styles from './styles.css';
import { modalCloseHandler, modalCloseNextModalHandler } from '../Modal/utils';
import { navigateToLogin } from '../../flows/shared/utils';
import closeBtn from '../../assets/images/Icon-button-close-beacon.svg';

const GuestUserLoginModal = () => {
  const { next, closeNextModal } = useContext(FlowContext);
  const modalDescription = `We noticed you have an existing unfinished application for the same account type. Please log in to 
  continue with that application, or click Continue to start over.`;

  return (
    <MFBeaconModal open removeCloseButton role="dialog">
      <span className="modal-close-icon">
        <MFBeaconIconButton
          id="loginModalCloseIcon"
          role="button"
          variant="tertiary"
          onClick={() => {
            modalCloseNextModalHandler(closeNextModal);
          }}
          label="Close Button">
          <img slot="icon" src={closeBtn} alt="close icon" />
        </MFBeaconIconButton>
      </span>
      <div className="beacon-modal__description">{modalDescription}</div>
      <>
        <div slot="action-zone" className="login-modal-btn-container">
          <MFBeaconButton
            variant="tertiary"
            noButtonMargin
            data-name="logInBtn"
            role="button"
            onClick={() => {
              modalCloseHandler();
              navigateToLogin();
            }}
            label="Log in"
          />
          <MFBeaconButton
            data-name="loginModalContinueBtn"
            noButtonMargin
            role="button"
            variant="primary"
            onClick={() => {
              modalCloseHandler();
              next('skipLogin')();
            }}
            label="Continue"
          />
        </div>
      </>
      <style jsx>{styles}</style>
    </MFBeaconModal>
  );
};

export default GuestUserLoginModal;
